// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see DocumentScanCaptureImageEvent
 */
export var DocumentScanCaptureImage = function (_a) {
    var documentCategory = _a.documentCategory, flowToken = _a.flowToken, side = _a.side, treatment = _a.treatment;
    return ({
        name: "Document Scan CaptureImage",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Scan",
            document_category: documentCategory !== undefined && documentCategory !== null ? documentCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentScanDetectImageEvent
 */
export var DocumentScanDetectImage = function (_a) {
    var captureTimeMs = _a.captureTimeMs, documentCategory = _a.documentCategory, flowToken = _a.flowToken, imageHeight = _a.imageHeight, imageWidth = _a.imageWidth, side = _a.side, treatment = _a.treatment;
    return ({
        name: "Document Scan DetectImage",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Scan",
            capture_time_ms: captureTimeMs !== undefined && captureTimeMs !== null ? captureTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            document_category: documentCategory !== undefined && documentCategory !== null ? documentCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            image_height: imageHeight !== undefined && imageHeight !== null ? imageHeight.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            image_width: imageWidth !== undefined && imageWidth !== null ? imageWidth.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            side: side !== undefined && side !== null ? side.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentUploadCompleteEvent
 */
export var DocumentUploadComplete = function (_a) {
    var clientScenario = _a.clientScenario, documentCategory = _a.documentCategory, flowToken = _a.flowToken, mimeType = _a.mimeType, ratePlan = _a.ratePlan, source = _a.source, trigger = _a.trigger;
    return ({
        name: "Document Upload Complete",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Upload",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            document_category: documentCategory !== undefined && documentCategory !== null ? documentCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            mime_type: mimeType !== undefined && mimeType !== null ? mimeType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentUploadOpenSystemPickerEvent
 */
export var DocumentUploadOpenSystemPicker = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, source = _a.source;
    return ({
        name: "Document Upload OpenSystemPicker",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Upload",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentUploadOpenCameraEvent
 */
export var DocumentUploadOpenCamera = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, source = _a.source, permissionStatus = _a.permissionStatus;
    return ({
        name: "Document Upload OpenCamera",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Upload",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            permission_status: permissionStatus !== undefined && permissionStatus !== null ? permissionStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentUploadReceiveErrorEvent
 */
export var DocumentUploadReceiveError = function (_a) {
    var clientScenario = _a.clientScenario, documentCategory = _a.documentCategory, errorMessage = _a.errorMessage, flowToken = _a.flowToken, mimeType = _a.mimeType, networkError = _a.networkError, responseCode = _a.responseCode, source = _a.source, trigger = _a.trigger;
    return ({
        name: "Document Upload ReceiveError",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Upload",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            document_category: documentCategory !== undefined && documentCategory !== null ? documentCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            mime_type: mimeType !== undefined && mimeType !== null ? mimeType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_error: networkError !== undefined && networkError !== null ? networkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            response_code: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentUploadRemoveEvent
 */
export var DocumentUploadRemove = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, source = _a.source;
    return ({
        name: "Document Upload Remove",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Upload",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentUploadStartEvent
 */
export var DocumentUploadStart = function (_a) {
    var clientScenario = _a.clientScenario, documentCategory = _a.documentCategory, flowToken = _a.flowToken, mimeType = _a.mimeType, ratePlan = _a.ratePlan, source = _a.source, trigger = _a.trigger;
    return ({
        name: "Document Upload Start",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Upload",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            document_category: documentCategory !== undefined && documentCategory !== null ? documentCategory.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            mime_type: mimeType !== undefined && mimeType !== null ? mimeType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentUploadSubmitEvent
 */
export var DocumentUploadSubmit = function (_a) {
    var clientScenario = _a.clientScenario, documentCount = _a.documentCount, flowToken = _a.flowToken, source = _a.source;
    return ({
        name: "Document Upload Submit",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "Upload",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            document_count: documentCount !== undefined && documentCount !== null ? documentCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentLegalDocumentViewDocumentEvent
 */
export var DocumentLegalDocumentViewDocument = function (_a) {
    var url = _a.url, token = _a.token, title = _a.title;
    return ({
        name: "Document LegalDocument ViewDocument",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "LegalDocument",
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            token: token !== undefined && token !== null ? token.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            title: title !== undefined && title !== null ? title.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DocumentViewLegalDocumentsListEvent
 */
export var DocumentViewLegalDocumentsList = function (_a) {
    var options = _a.options;
    return ({
        name: "Document View LegalDocumentsList",
        parameters: {
            cdf_entity: "Document",
            cdf_action: "View",
            options: options !== undefined && options !== null ? options.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
